<header class="flex items-center min-h-11">
  <h1 class="m-0 mr-8 font-medium text-gray-900 text-2xl text-nowrap truncate">
    {{ title | translate }}
  </h1>
  <ng-content></ng-content>
</header>
